import customerApi from '../../components/apis/customerApi';

export function getInfoContentService(params) {
  return customerApi.get('/api/info-content', { params }).then((res) => res.data);
}

export function getSocialsInfoContentService() {
  return customerApi.get('/api/info-content/socials').then((res) => res.data);
}
